module.exports = __webpack_public_path__ + "static/media/Illus-Dressing_3@2x.cb0f1554.png";